module.exports = __webpack_public_path__ + "static/media/fruits_5.769194d1.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_5.csv
// module id = 717
// module chunks = 0